



// import React, { useState, useEffect } from "react";

// import {
//   FaRupeeSign,
//   FaChartLine,
//   FaShoppingBag,
//   FaFileInvoice,
//   FaExclamationTriangle,
// } from "react-icons/fa";

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
// } from "recharts";

// import axios from "axios";





// // const cardStyle = {
// //   borderRadius: "18px",
// //   color: "#fff",
// //   padding: "20px",
// //   height: "100px",
// // };
// const cardStyle = {
//   borderRadius: "18px",
//   color: "#fff",
//   padding: "20px",
//   height: "100px",
//   overflow: "hidden",
// };
// const Overview = ({ clientData }) => {
//   const [salesData, setSalesData] = useState([]);
// const [paymentData, setPaymentData] = useState([]);


//   const [expenseData, setExpenseData] = useState([]);
//   const [todaySales, setTodaySales] = useState(0);
//   const [purchaseBill, setPurchaseBill] = useState([]);
//   const [todayPurchase, setTodayPurchase] = useState(0);
//   const [lowStock, setLowStock] = useState([]);
//   const [saleBill, setSaleBill] = useState([]);
//   const [inventoryData, setInventoryData] = useState([]);

//   const clientId = clientData?.id;



//   // =========================
// // EXPENSE CATEGORY API
// // =========================

// const fetchInventory = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
//     );

//     console.log("INVENTORY DATA:", res.data);

//     setInventoryData(Array.isArray(res.data) ? res.data : []);

//   } catch (error) {
//     console.error(
//       "Inventory error:",
//       error.response?.data || error.message
//     );

//     setInventoryData([]);
//   }
// };
// const fetchExpenseCategory = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-expcat/${clientId}`
//     );

//     console.log("EXPENSE CATEGORY API RESPONSE:", res.data);

//     const colors = [
//       "#FF6384",
//       "#36A2EB",
//       "#FFCE56",
//       "#4BC0C0",
//       "#9966FF",
//       "#FF9F40",
//       "#4CAF50",
//     ];

//     const formattedData = res.data.map((item, index) => ({
//       name: item.cat_name || "Other",

//       // Abhi category API me amount nahi aa raha,
//       // isliye har category ko 1 count kar rahe hain
//       value: 1,

//       color: colors[index % colors.length],
//     }));

//     console.log("FINAL EXPENSE GRAPH DATA:", formattedData);

//     setExpenseData(formattedData);

//   } catch (error) {
//     console.error(
//       "Expense Category API Error:",
//       error.response?.data || error.message
//     );

//     setExpenseData([]);
//   }
// };
//   const fetchLowStock = async () => {
//     try {
//       const res = await axios.get(
//         `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
//       );

//       const filteredData = res.data.filter(
//         (item) =>
//           Number(item.stock) <= Number(item.min_to_maintain)
//       );

//       setLowStock(filteredData);
//     } catch (error) {
//       console.log("Low stock error:", error);
//     }
//   };

//   // =========================
//   // SALE HISTORY API
//   // =========================
// // const fetchSaleHistory = async () => {
// //   try {
// //     const res = await axios.get(
// //       `https://api.dectwinbilling.com/fetch-sale-history/${clientId}`
// //     );
// // console.log(res,"sale-history")
// //     const sales = Array.isArray(res.data) ? res.data : [];

// //     console.log("SALE HISTORY:", sales);

// //     // =========================
// //     // SORT SALE BILL
// //     // =========================
// //     const sortedData = [...sales].sort(
// //       (a, b) => Number(b.invoiceNo || 0) - Number(a.invoiceNo || 0)
// //     );

// //     setSaleBill(sortedData);

// //     // =========================
// //     // TODAY'S SALES
// //     // =========================
// //     const today = new Date().toLocaleDateString("en-CA");

// //     const todaysSales = sales.filter((sale) => {
// //       const saleDate = sale.date?.split(" ")[0];
// //       return saleDate === today;
// //     });

// //     const totalToday = todaysSales.reduce((total, sale) => {
// //       return total + Number(sale.totalSP || 0);
// //     }, 0);

// //     setTodaySales(totalToday);

// //     // =========================
// //     // MONTHLY SALES GRAPH
// //     // =========================

// //     const now = new Date();

// //     const currentYear = now.getFullYear();
// //     const currentMonth = now.getMonth();

// //     // Current month me kitne days hain
// //     const daysInMonth = new Date(
// //       currentYear,
// //       currentMonth + 1,
// //       0
// //     ).getDate();

// //     // Pehle har day ko 0 se initialize karo
// //     const dailySales = {};

// //     for (let day = 1; day <= daysInMonth; day++) {
// //       dailySales[day] = 0;
// //     }

// //     // Sale history ko current month ke days me group karo
// //     sales.forEach((sale) => {
// //       if (!sale.date) return;

// //       // Example:
// //       // 2026-08-15 12:30:00
// //       const saleDate = sale.date.split(" ")[0];

// //       const [year, month, day] = saleDate
// //         .split("-")
// //         .map(Number);

// //       // Sirf current month ki sales
// //       if (
// //         year === currentYear &&
// //         month === currentMonth + 1
// //       ) {
// //         dailySales[day] += Number(sale.totalSP || 0);
// //       }
// //     });

// //     // Recharts ke liye array
// //     const graphData = Object.keys(dailySales).map((day) => ({
// //       day: Number(day),
// //       sales: Number(dailySales[day].toFixed(2)),
// //     }));

// //     console.log("MONTHLY GRAPH DATA:", graphData);

// //     setSalesData(graphData);

// //   } catch (error) {
// //     console.error(
// //       "Sale history error:",
// //       error.response?.data || error.message
// //     );

// //     setSaleBill([]);
// //     setTodaySales(0);
// //     setSalesData([]);
// //   }
// // };
// const fetchSaleHistory = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-sale-history/${clientId}`
//     );

//     console.log("=================================");
//     console.log("SALE HISTORY API RESPONSE:", res);
//     console.log("SALE HISTORY API DATA:", res.data);
//     console.log("=================================");

//     const sales = Array.isArray(res.data) ? res.data : [];

//     console.log("TOTAL SALES RECORDS:", sales.length);
// // =========================
// // DYNAMIC PAYMENT COLLECTION
// // =========================
// const paymentColors = [
//   "#4CAF50",
//   "#9C27B0",
//   "#2196F3",
//   "#FF9800",
//   "#F44336",
//   "#00BCD4",
//   "#795548",
//   "#607D8B",
// ];

// const paymentTotals = {};

// sales.forEach((sale) => {
//   const paymentMethod = String(
//     sale.payment_method || ""
//   ).trim();

//   const receivedAmount = Number(
//     sale.received || 0
//   );

//   // Empty payment method ignore
//   if (!paymentMethod || receivedAmount <= 0) {
//     return;
//   }

//   if (!paymentTotals[paymentMethod]) {
//     paymentTotals[paymentMethod] = 0;
//   }

//   paymentTotals[paymentMethod] += receivedAmount;
// });

// const dynamicPaymentData = Object.entries(
//   paymentTotals
// ).map(([name, value], index) => ({
//   name,
//   value: Number(value.toFixed(2)),
//   color:
//     paymentColors[
//       index % paymentColors.length
//     ],
// }));

// console.log("PAYMENT TOTALS:", paymentTotals);

// setPaymentData(dynamicPaymentData);
//     // =========================
//     // SORT SALE BILL
//     // =========================
//     const sortedData = [...sales].sort(
//       (a, b) =>
//         Number(b.invoiceNo || 0) -
//         Number(a.invoiceNo || 0)
//     );

//     console.log("SORTED SALE DATA:", sortedData);

//     setSaleBill(sortedData);

//     // =========================
//     // TODAY'S SALES
//     // =========================
//     const today = new Date().toLocaleDateString("en-CA");

//     console.log("TODAY DATE:", today);

//     const todaysSales = sales.filter((sale) => {
//       if (!sale.date) return false;

//       const saleDate = sale.date.split(" ")[0];

//       console.log(
//         "SALE DATE:",
//         saleDate,
//         "TOTAL:",
//         sale.totalSP
//       );

//       return saleDate === today;
//     });

//     console.log("TODAY'S SALES RECORDS:", todaysSales);

//     const totalToday = todaysSales.reduce(
//       (total, sale) => {
//         return total + Number(sale.totalSP || 0);
//       },
//       0
//     );

//     console.log("TODAY'S TOTAL SALES:", totalToday);

//     setTodaySales(totalToday);

//     // =========================
//     // MONTHLY SALES GRAPH
//     // =========================

//     const now = new Date();

//     const currentYear = now.getFullYear();
//     const currentMonth = now.getMonth();

//     console.log("CURRENT YEAR:", currentYear);
//     console.log("CURRENT MONTH:", currentMonth + 1);

//     // Current month ke total days
//     const daysInMonth = new Date(
//       currentYear,
//       currentMonth + 1,
//       0
//     ).getDate();

//     console.log("DAYS IN CURRENT MONTH:", daysInMonth);

//     // Har day ko 0 se initialize
//     const dailySales = {};

//     for (let day = 1; day <= daysInMonth; day++) {
//       dailySales[day] = 0;
//     }

//     // =========================
//     // GROUP SALES BY DAY
//     // =========================

//     sales.forEach((sale) => {
//       if (!sale.date) {
//         console.log("SALE WITHOUT DATE:", sale);
//         return;
//       }

//       const saleDate = sale.date.split(" ")[0];

//       const [year, month, day] = saleDate
//         .split("-")
//         .map(Number);

//       const saleAmount = Number(sale.totalSP || 0);

//       console.log(
//         "PROCESSING SALE:",
//         {
//           date: saleDate,
//           year,
//           month,
//           day,
//           amount: saleAmount,
//         }
//       );

//       // Sirf current month ki sales
//       if (
//         year === currentYear &&
//         month === currentMonth + 1
//       ) {
//         dailySales[day] += saleAmount;

//         console.log(
//           `DAY ${day} SALE ADDED:`,
//           saleAmount,
//           "DAY TOTAL:",
//           dailySales[day]
//         );
//       }
//     });

//     console.log(
//       "DAILY SALES OBJECT:",
//       dailySales
//     );

//     // =========================
//     // RECHARTS DATA
//     // =========================

//     const graphData = Object.keys(dailySales).map(
//       (day) => ({
//         day: Number(day),
//         sales: Number(
//           dailySales[day].toFixed(2)
//         ),
//       })
//     );

//     console.log(
//       "FINAL MONTHLY GRAPH DATA:",
//       graphData
//     );

//     setSalesData(graphData);

//   } catch (error) {
//     console.error(
//       "SALE HISTORY API ERROR:",
//       error
//     );

//     console.error(
//       "ERROR RESPONSE:",
//       error.response?.data
//     );

//     console.error(
//       "ERROR STATUS:",
//       error.response?.status
//     );

//     setSaleBill([]);
//     setTodaySales(0);
//     setSalesData([]);
//   }
// };

//   // =========================
//   // PURCHASE API
//   // =========================
//   const fetchPurchase = async () => {
//     try {
//       const res = await axios.get(
//         `https://api.dectwinbilling.com/fetch-purchase-bill/${clientId}`
//       );

//       const sortedData = [...res.data].sort(
//         (a, b) => b.id - a.id
//       );

//       setPurchaseBill(sortedData);

//       // Today's date
//       const today = new Date().toLocaleDateString("en-CA");

//       // Today's purchases
//       const todaysPurchases = res.data.filter((purchase) => {
//         const purchaseDate = purchase.date?.split(" ")[0];

//         return purchaseDate === today;
//       });

//       // Today's purchase total
//       const totalTodayPurchase = todaysPurchases.reduce(
//         (total, purchase) => {
//           return total + Number(purchase.payable || 0);
//         },
//         0
//       );

//       setTodayPurchase(totalTodayPurchase);

//     } catch (error) {
//       console.log("Purchase error:", error);
//     }
//   };

//   // =========================
//   // LOAD ALL API DATA
//   // =========================
// useEffect(() => {
//   if (clientData?.id) {
//     fetchSaleHistory();
//     fetchPurchase();
//     fetchLowStock();
//     fetchExpenseCategory();
//     fetchInventory(); // ADD
//   }
// }, [clientData?.id]);
//   return (
//     <div
//       className="container-fluid p-3"
//       style={{
//         background: "#f2f4f8",
//         minHeight: "100vh",
//       }}
//     >

//       {/* =========================
//           TOP CARDS
//       ========================= */}
//       <div className="row g-3 mb-3">

//         {/* TODAY'S SALES */}
//         <div className="col-lg-3 col-md-6">
//           <div
//             style={{
//               ...cardStyle,
//               background:
//                 "linear-gradient(135deg,#18a84c,#27d863)",
//             }}
//           >
//             {/* <div className="d-flex justify-content-between align-items-center">

//               <div>
//                 <h6>Today's Sales</h6>

//                 <h1 className="fw-bold">
//                   <FaRupeeSign size={20} />{" "}
//                   {todaySales.toLocaleString("en-IN", {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   })}
//                 </h1>
//               </div>

//               <FaChartLine
//                 size={40}
//                 opacity={0.7}
//               />

//             </div> */}
//             <div
//   className="d-flex justify-content-between align-items-center"
//   style={{
//     height: "60px",
//     position: "relative",
//   }}
// >
//   <div style={{ minWidth: 0 }}>
//     <h6
//       className="mb-1"
//       style={{
//         fontSize: "15px",
//         whiteSpace: "nowrap",
//       }}
//     >
//       Today's Sales
//     </h6>

//     <h1
//       className="fw-bold mb-0"
//       style={{
//         fontSize: "26px",
//         lineHeight: "1",
//         whiteSpace: "nowrap",
//       }}
//     >
//       ₹{" "}
//       {Number(todaySales || 0).toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       })}
//     </h1>
//   </div>

//   <FaChartLine
//     size={38}
//     opacity={0.7}
//     style={{
//       flexShrink: 0,
//       marginLeft: "8px",
//     }}
//   />
// </div>
//           </div>
//         </div>

//         {/* TODAY'S PURCHASE */}
//         <div className="col-lg-3 col-md-6">
//           <div
//             style={{
//               ...cardStyle,
//               background:
//                 "linear-gradient(135deg,#2526b7,#4f4cff)",
//             }}
//           >
//             <div className="d-flex justify-content-between align-items-center">

//               <div>
//                 <h6>Today's Purchase</h6>

//                 <h1 className="fw-bold">
//                   <FaRupeeSign size={20} />{" "}
//                   {todayPurchase.toLocaleString("en-IN", {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   })}
//                 </h1>
//               </div>

//               <FaShoppingBag
//                 size={40}
//                 opacity={0.7}
//               />

//             </div>
//           </div>
//         </div>

//         {/* INVOICES */}
//         <div className="col-lg-3 col-md-6">
//           <div
//             style={{
//               ...cardStyle,
//               background:
//                 "linear-gradient(135deg,#1887a6,#3aa8d0)",
//             }}
//           >
//             <div className="d-flex justify-content-between align-items-center">

//               <div>
//                 <h6>Invoices</h6>

//                 <h1 className="fw-bold">
//                   {saleBill.length}
//                 </h1>
//               </div>

//               <FaFileInvoice
//                 size={40}
//                 opacity={0.7}
//               />

//             </div>
//           </div>
//         </div>

//         {/* LOW STOCK */}
//         <div className="col-lg-3 col-md-6">
//           <div
//             style={{
//               ...cardStyle,
//               background:
//                 "linear-gradient(135deg,#e74c3c,#ff6f61)",
//             }}
//           >
//             <div className="d-flex justify-content-between align-items-center">

//               <div>
//                 <h6>Low Stock Items</h6>

//                 <h1 className="fw-bold">
//                   {lowStock.length}
//                 </h1>
//               </div>

//               <FaExclamationTriangle
//                 size={40}
//                 opacity={0.7}
//               />

//             </div>
//           </div>
//         </div>

//       </div>


//       {/* =========================
//           CHART SECTION
//       ========================= */}
//       <div className="row g-3 mb-3">

//         {/* MONTHLY SALES */}
//     <div className="col-lg-6">
//   <div className="card border-0 shadow-sm rounded-4 p-3">

//     <h4 className="fw-bold mb-3">
//       Monthly Sales Overview
//     </h4>

//     <ResponsiveContainer
//       width="100%"
//       height={250}
//     >
//       <LineChart
//         data={salesData}
//         margin={{
//           top: 5,
//           right: 20,
//           left: 10,
//           bottom: 5,
//         }}
//       >
//         <CartesianGrid
//           strokeDasharray="5 5"
//           stroke="#e5e7eb"
//         />

//         <XAxis
//           dataKey="day"
//           tick={{ fontSize: 12 }}
//           label={{
//             value: "Day",
//             position: "insideBottom",
//             offset: -2,
//           }}
//         />

//         <YAxis
//           tick={{ fontSize: 12 }}
//           tickFormatter={(value) => `₹${value}`}
//         />

//         <Tooltip
//           formatter={(value) => [
//             `₹${Number(value).toLocaleString("en-IN", {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })}`,
//             "Sales",
//           ]}
//           labelFormatter={(day) => `Day ${day}`}
//         />

//         <Line
//           type="monotone"
//           dataKey="sales"
//           stroke="#00BCD4"
//           strokeWidth={3}
//           dot={{
//             r: 4,
//             fill: "#00BCD4",
//           }}
//           activeDot={{
//             r: 6,
//           }}
//         />
//       </LineChart>
//     </ResponsiveContainer>

//   </div>
// </div>


//    {/* PAYMENT METHODS */}
// <div className="col-lg-3 col-md-6">
//   <div
//     className="card border-0 shadow-sm rounded-4 h-100"
//     style={{
//       minHeight: "300px",
//       overflow: "hidden",
//     }}
//   >

//     {/* Header */}
//     <div className="card-header bg-white border-0 py-3">
//       <h4
//         className="fw-bold mb-0"
//         style={{ fontSize: "18px" }}
//       >
//         Collection by Payment Methods
//       </h4>
//     </div>

//     {/* Pie Chart */}
//     <div
//       style={{
//         width: "100%",
//         height: "210px",
//         padding: "5px 10px",
//       }}
//     >
//       {paymentData && paymentData.length > 0 ? (
//         <ResponsiveContainer
//           width="100%"
//           height="100%"
//         >
//           <PieChart>
//             <Pie
//               data={paymentData}
//               dataKey="value"
//               nameKey="name"
//               cx="50%"
//               cy="50%"
//               outerRadius={70}
//               label
//               labelLine={false}
//             >
//               {paymentData.map((entry, index) => (
//                 <Cell
//                   key={`payment-cell-${index}`}
//                   fill={entry.color}
//                 />
//               ))}
//             </Pie>

//             <Tooltip
//               formatter={(value, name) => [
//                 `₹${Number(value || 0).toLocaleString(
//                   "en-IN",
//                   {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   }
//                 )}`,
//                 name,
//               ]}
//             />
//           </PieChart>
//         </ResponsiveContainer>
//       ) : (
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{
//             height: "100%",
//             color: "#777",
//             fontSize: "14px",
//           }}
//         >
//           No payment collection found
//         </div>
//       )}
//     </div>

//     {/* Dynamic Payment Details */}
//     <div
//       style={{
//         padding: "8px 12px 15px",
//         borderTop: "1px solid #eee",
//       }}
//     >
//       {paymentData && paymentData.length > 0 ? (
//         <div
//           className="d-flex flex-column"
//           style={{
//             gap: "7px",
//           }}
//         >
//           {paymentData.map((entry, index) => (
//             <div
//               key={`payment-detail-${index}`}
//               className="d-flex justify-content-between align-items-center"
//               style={{
//                 fontSize: "13px",
//               }}
//             >
//              <span>
//   <span
//     className="rounded-circle d-inline-block me-2"
//     style={{
//       width: "10px",
//       height: "10px",
//       background: entry.color,
//     }}
//   />

//   {entry.name}
// </span>
// {/* 
//               <strong>
//                 ₹
//                 {Number(entry.value || 0).toLocaleString(
//                   "en-IN",
//                   {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   }
//                 )}
//               </strong> */}
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div
//           className="text-center text-muted"
//           style={{ fontSize: "13px" }}
//         >
//           No payment data
//         </div>
//       )}
//     </div>

//   </div>
// </div>
//         {/* EMPTY CARD */}
//         <div className="col-lg-3">
//   <div
//     className="card border-0 shadow-sm rounded-4"
//     style={{
//       height: "100%",
//       overflow: "hidden",
//     }}
//   >
//     <div className="card-header bg-white border-0">
//       <h4 className="fw-bold mb-0">
//         Inventory Stock
//       </h4>
//     </div>

//     <div
//       className="table-responsive"
//       style={{
//         maxHeight: "220px",
//         overflowY: "auto",
//       }}
//     >
//       <table className="table table-sm mb-0">
//         <thead
//           style={{
//             background: "#1fb6d4",
//             color: "#fff",
//             position: "sticky",
//             top: 0,
//           }}
//         >
//           <tr>
//             <th>Item Name</th>
//             <th>Stock</th>
//           </tr>
//         </thead>

//         <tbody>
//           {inventoryData.length > 0 ? (
//             inventoryData.slice(0, 10).map((item, index) => (
//               <tr key={item.id || index}>
//                 <td>
//                   {item.item_name ||
//                     item.itemName ||
//                     item.name ||
//                     "-"}
//                 </td>

//                 <td>
//                   {item.stock ?? 0}
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td
//                 colSpan="2"
//                 className="text-center text-muted py-4"
//               >
//                 No inventory data found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// </div>

//       </div>


//       {/* =========================
//           LATEST SALES
//       ========================= */}
//       <div className="row g-3">

//         <div className="col-lg-9">

//           <div className="card border-0 shadow-sm rounded-4">

//             <div className="card-header bg-white border-0 d-flex justify-content-between">

//               <h4 className="fw-bold">
//                 Latest Sale Transactions
//               </h4>

//               <span
//                 style={{
//                   color: "#ff5b7f",
//                   cursor: "pointer",
//                 }}
//               >
//                 See all
//               </span>

//             </div>


//             <div className="table-responsive">

//               <table className="table mb-0">

//                 <thead
//                   style={{
//                     background: "#1fb6d4",
//                     color: "#fff",
//                   }}
//                 >
//                   <tr>
//                     <th>Inv. No.</th>
//                     <th>Customer Name</th>
//                     <th>Date</th>
//                     <th>Payment Mode</th>
//                     <th>Total</th>
//                   </tr>
//                 </thead>

// <tbody>
//   {saleBill.length > 0 ? (
//     saleBill.slice(0, 5).map((item, index) => (
//       <tr key={item.id || item.invoiceNo || index}>
        
//         <td>
//           {item.invoiceNo || item.id || "-"}
//         </td>

//         <td>
//           {item.customerName ||
//             item.customer_name ||
//             item.customer ||
//             item.name ||
//             "-"}
//         </td>

//         <td>
//           {item.date || "-"}
//         </td>

//         <td>
//         {item.payment_method ||
//   item.paymentMethod ||
//   item.payment_mode ||
//   item.paymentMode ||
//   item.mode ||
//   item.payment ||
//   "-"}
//         </td>

//         <td>
//           ₹
//           {Number(
//             item.totalSP ||
//             item.total ||
//             item.grandTotal ||
//             item.amount ||
//             0
//           ).toLocaleString("en-IN", {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//           })}
//         </td>

//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td
//         colSpan="5"
//         className="text-center py-4"
//       >
//         No sale transactions found
//       </td>
//     </tr>
//   )}
// </tbody>

//               </table>

//             </div>

//           </div>

//         </div>


//         {/* EXPENSES */}
//         {/* <div className="col-lg-3">

//           <div
//             className="card border-0 shadow-sm rounded-4"
//             style={{
//               minHeight: "280px",
//             }}
//           >

//             <div className="card-header bg-white border-0">

//               <h4 className="fw-bold">
//                 Expenses by Category
//               </h4>

//             </div>

//           </div>

//         </div> */}
// <div className="col-lg-3">
//   <div
//     className="card border-0 shadow-sm rounded-4"
//     style={{
//       minHeight: "280px",
//       overflow: "hidden",
//     }}
//   >
//     <div className="card-header bg-white border-0">
//       <h4 className="fw-bold mb-0">
//         Expenses by Category
//       </h4>
//     </div>

//     {expenseData && expenseData.length > 0 ? (
//       <div
//         style={{
//           width: "100%",
//           height: "220px",
//         }}
//       >
//         <ResponsiveContainer width="100%" height="100%">
//           <PieChart>
//             <Pie
//               data={expenseData}
//               dataKey="value"
//               nameKey="name"
//               cx="50%"
//               cy="45%"
//               outerRadius={70}
//               label
//             >
//               {expenseData.map((entry, index) => (
//                 <Cell
//                   key={`expense-${index}`}
//                   fill={entry.color}
//                 />
//               ))}
//             </Pie>

//             <Tooltip />
//           </PieChart>
//         </ResponsiveContainer>
//       </div>
//     ) : (
//       <div className="text-center text-muted py-5">
//         No expense data found
//       </div>
//     )}
//   </div>
// </div>
//       </div>

//     </div>
//   );
// };

// export default Overview;
import React, { useState, useEffect } from "react";

import {
  FaRupeeSign,
  FaChartLine,
  FaShoppingBag,
  FaFileInvoice,
  FaExclamationTriangle,
} from "react-icons/fa";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import axios from "axios";

const cardStyle = {
  minHeight: "96px",
  overflow: "hidden",
};

const Overview = ({ clientData }) => {
  const [salesData, setSalesData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [todaySales, setTodaySales] = useState(0);
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [todayPurchase, setTodayPurchase] = useState(0);
  const [lowStock, setLowStock] = useState([]);
  const [saleBill, setSaleBill] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);

  const clientId = clientData?.id;

  // =========================
  // INVENTORY API
  // =========================
  const fetchInventory = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
      );

      console.log("INVENTORY DATA:", res.data);

      setInventoryData(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error(
        "Inventory error:",
        error.response?.data || error.message
      );

      setInventoryData([]);
    }
  };

  // =========================
  // EXPENSE CATEGORY API
  // =========================
  const fetchExpenseCategory = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-expcat/${clientId}`
      );

      console.log("EXPENSE CATEGORY API RESPONSE:", res.data);

      const colors = [
        "#FF6384",
        "#36A2EB",
        "#FFCE56",
        "#4BC0C0",
        "#9966FF",
        "#FF9F40",
        "#4CAF50",
      ];

      const formattedData = res.data.map((item, index) => ({
        name: item.cat_name || "Other",
        value: 1,
        color: colors[index % colors.length],
      }));

      console.log("FINAL EXPENSE GRAPH DATA:", formattedData);

      setExpenseData(formattedData);
    } catch (error) {
      console.error(
        "Expense Category API Error:",
        error.response?.data || error.message
      );

      setExpenseData([]);
    }
  };

  // =========================
  // LOW STOCK API
  // =========================
  const fetchLowStock = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
      );

      const filteredData = res.data.filter(
        (item) =>
          Number(item.stock) <= Number(item.min_to_maintain)
      );

      setLowStock(filteredData);
    } catch (error) {
      console.log("Low stock error:", error);
    }
  };

  // =========================
  // SALE HISTORY API
  // =========================
  const fetchSaleHistory = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-sale-history/${clientId}`
      );

      const sales = Array.isArray(res.data) ? res.data : [];

      // =========================
      // PAYMENT COLLECTION
      // =========================
      const paymentColors = [
        "#4CAF50",
        "#9C27B0",
        "#2196F3",
        "#FF9800",
        "#F44336",
        "#00BCD4",
        "#795548",
        "#607D8B",
      ];

      const paymentTotals = {};

      sales.forEach((sale) => {
        const paymentMethod = String(
          sale.payment_method || ""
        ).trim();

        const receivedAmount = Number(
          sale.received || 0
        );

        if (!paymentMethod || receivedAmount <= 0) {
          return;
        }

        if (!paymentTotals[paymentMethod]) {
          paymentTotals[paymentMethod] = 0;
        }

        paymentTotals[paymentMethod] += receivedAmount;
      });

      const dynamicPaymentData = Object.entries(
        paymentTotals
      ).map(([name, value], index) => ({
        name,
        value: Number(value.toFixed(2)),
        color:
          paymentColors[
            index % paymentColors.length
          ],
      }));

      setPaymentData(dynamicPaymentData);

      // =========================
      // SORT SALES
      // =========================
      const sortedData = [...sales].sort(
        (a, b) =>
          Number(b.invoiceNo || 0) -
          Number(a.invoiceNo || 0)
      );

      setSaleBill(sortedData);

      // =========================
      // TODAY SALES
      // =========================
      const today = new Date().toLocaleDateString(
        "en-CA"
      );

      const todaysSales = sales.filter((sale) => {
        if (!sale.date) return false;

        const saleDate = sale.date.split(" ")[0];

        return saleDate === today;
      });

      const totalToday = todaysSales.reduce(
        (total, sale) =>
          total + Number(sale.totalSP || 0),
        0
      );

      setTodaySales(totalToday);

      // =========================
      // MONTHLY SALES
      // =========================
      const now = new Date();

      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const daysInMonth = new Date(
        currentYear,
        currentMonth + 1,
        0
      ).getDate();

      const dailySales = {};

      for (
        let day = 1;
        day <= daysInMonth;
        day++
      ) {
        dailySales[day] = 0;
      }

      sales.forEach((sale) => {
        if (!sale.date) return;

        const saleDate =
          sale.date.split(" ")[0];

        const [year, month, day] =
          saleDate.split("-").map(Number);

        if (
          year === currentYear &&
          month === currentMonth + 1
        ) {
          dailySales[day] += Number(
            sale.totalSP || 0
          );
        }
      });

      const graphData = Object.keys(
        dailySales
      ).map((day) => ({
        day: Number(day),
        sales: Number(
          dailySales[day].toFixed(2)
        ),
      }));

      setSalesData(graphData);
    } catch (error) {
      console.error(
        "SALE HISTORY API ERROR:",
        error
      );

      setSaleBill([]);
      setTodaySales(0);
      setSalesData([]);
    }
  };

  // =========================
  // PURCHASE API
  // =========================
  const fetchPurchase = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-purchase-bill/${clientId}`
      );

      const sortedData = [...res.data].sort(
        (a, b) => b.id - a.id
      );

      setPurchaseBill(sortedData);

      const today = new Date().toLocaleDateString(
        "en-CA"
      );

      const todaysPurchases = res.data.filter(
        (purchase) => {
          const purchaseDate =
            purchase.date?.split(" ")[0];

          return purchaseDate === today;
        }
      );

      const totalTodayPurchase =
        todaysPurchases.reduce(
          (total, purchase) =>
            total +
            Number(purchase.payable || 0),
          0
        );

      setTodayPurchase(totalTodayPurchase);
    } catch (error) {
      console.log("Purchase error:", error);
    }
  };

  // =========================
  // LOAD DATA
  // =========================
  useEffect(() => {
    if (clientData?.id) {
      fetchSaleHistory();
      fetchPurchase();
      fetchLowStock();
      fetchExpenseCategory();
      fetchInventory();
    }
  }, [clientData?.id]);

  return (
<div
  className="container-fluid px-1 py-3"
  style={{
    background: "#f2f4f8",
    minHeight: "100vh",
  }}
>
     
    {/* =========================
    TOP CARDS
========================= */}
<div className="row g-2 g-md-3 mb-3 justify-content-center">

  {/* TODAY'S SALES */}
  <div className="col-6 col-md-5 col-lg-3 col-xl-3">
    <div
      className="card border-0 shadow-sm rounded-3 h-100 text-white overflow-hidden"
      style={{
        minHeight: "76px",
        background:
          "linear-gradient(135deg,#18a84c,#27d863)",
      }}
    >
      <div className="card-body px-3 py-2 d-flex align-items-center justify-content-between gap-2">

        <div className="min-w-0">
          <div
            className="fw-semibold text-nowrap"
            style={{ fontSize: "12px" }}
          >
            Today's Sales
          </div>

          <div
            className="fw-bold text-nowrap mt-1"
            style={{
              fontSize: "20px",
              lineHeight: "1.1",
            }}
          >
            ₹{Number(todaySales || 0).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>

        <FaChartLine
          size={28}
          className="flex-shrink-0 opacity-75"
        />
      </div>
    </div>
  </div>

  {/* TODAY'S PURCHASE */}
  <div className="col-6 col-md-5 col-lg-3 col-xl-3">
    <div
      className="card border-0 shadow-sm rounded-3 h-100 text-white overflow-hidden"
      style={{
        minHeight: "76px",
        background:
          "linear-gradient(135deg,#2526b7,#4f4cff)",
      }}
    >
      <div className="card-body px-3 py-2 d-flex align-items-center justify-content-between gap-2">

        <div className="min-w-0">
          <div
            className="fw-semibold text-nowrap"
            style={{ fontSize: "12px" }}
          >
            Today's Purchase
          </div>

          <div
            className="fw-bold text-nowrap mt-1"
            style={{
              fontSize: "20px",
              lineHeight: "1.1",
            }}
          >
            ₹{Number(todayPurchase || 0).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>

        <FaShoppingBag
          size={28}
          className="flex-shrink-0 opacity-75"
        />
      </div>
    </div>
  </div>

  {/* INVOICES */}
  <div className="col-6 col-md-5 col-lg-3 col-xl-3">
    <div
      className="card border-0 shadow-sm rounded-3 h-100 text-white overflow-hidden"
      style={{
        minHeight: "76px",
        background:
          "linear-gradient(135deg,#1887a6,#3aa8d0)",
      }}
    >
      <div className="card-body px-3 py-2 d-flex align-items-center justify-content-between gap-2">

        <div className="min-w-0">
          <div
            className="fw-semibold text-nowrap"
            style={{ fontSize: "12px" }}
          >
            Invoices
          </div>

          <div
            className="fw-bold mt-1"
            style={{
              fontSize: "23px",
              lineHeight: "1.1",
            }}
          >
            {saleBill.length}
          </div>
        </div>

        <FaFileInvoice
          size={28}
          className="flex-shrink-0 opacity-75"
        />
      </div>
    </div>
  </div>

  {/* LOW STOCK */}
  <div className="col-6 col-md-5 col-lg-3 col-xl-3">
    <div
      className="card border-0 shadow-sm rounded-3 h-100 text-white overflow-hidden"
      style={{
        minHeight: "76px",
        background:
          "linear-gradient(135deg,#e74c3c,#ff6f61)",
      }}
    >
      <div className="card-body px-3 py-2 d-flex align-items-center justify-content-between gap-2">

        <div className="min-w-0">
          <div
            className="fw-semibold text-nowrap"
            style={{ fontSize: "12px" }}
          >
            Low Stock Items
          </div>

          <div
            className="fw-bold mt-1"
            style={{
              fontSize: "23px",
              lineHeight: "1.1",
            }}
          >
            {lowStock.length}
          </div>
        </div>

        <FaExclamationTriangle
          size={28}
          className="flex-shrink-0 opacity-75"
        />
      </div>
    </div>
  </div>

</div>

      {/* =========================
          CHART SECTION
      ========================= */}
      <div className="row g-3 mb-3">

        {/* MONTHLY SALES */}
        <div className="col-12 col-lg-6">
          <div className="card border-0 shadow-sm rounded-4 p-3 h-100">

            <h4 className="fw-bold mb-3">
              Monthly Sales Overview
            </h4>

            <ResponsiveContainer
              width="100%"
              height={250}
            >
              <LineChart
                data={salesData}
                margin={{
                  top: 5,
                  right: 20,
                  left: 10,
                  bottom: 5,
                }}
              >
                <CartesianGrid
                  strokeDasharray="5 5"
                  stroke="#e5e7eb"
                />

                <XAxis
                  dataKey="day"
                  tick={{ fontSize: 12 }}
                  label={{
                    value: "Day",
                    position: "insideBottom",
                    offset: -2,
                  }}
                />

                <YAxis
                  tick={{ fontSize: 12 }}
                  tickFormatter={(value) =>
                    `₹${value}`
                  }
                />

                <Tooltip
                  formatter={(value) => [
                    `₹${Number(
                      value
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`,
                    "Sales",
                  ]}
                  labelFormatter={(day) =>
                    `Day ${day}`
                  }
                />

                <Line
                  type="monotone"
                  dataKey="sales"
                  stroke="#00BCD4"
                  strokeWidth={3}
                  dot={{
                    r: 4,
                    fill: "#00BCD4",
                  }}
                  activeDot={{
                    r: 6,
                  }}
                />
              </LineChart>
            </ResponsiveContainer>

          </div>
        </div>

        {/* PAYMENT METHODS */}
        <div className="col-12 col-md-6 col-lg-3">
          <div
            className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden"
            style={{
              minHeight: "300px",
            }}
          >
            <div className="card-header bg-white border-0 py-3">
              <h4
                className="fw-bold mb-0"
                style={{ fontSize: "18px" }}
              >
                Collection by Payment Methods
              </h4>
            </div>

            <div
              style={{
                width: "100%",
                height: "210px",
                padding: "5px 10px",
              }}
            >
              {paymentData &&
              paymentData.length > 0 ? (
                <ResponsiveContainer
                  width="100%"
                  height="100%"
                >
                  <PieChart>
                    <Pie
                      data={paymentData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={70}
                      label
                      labelLine={false}
                    >
                      {paymentData.map(
                        (entry, index) => (
                          <Cell
                            key={`payment-cell-${index}`}
                            fill={entry.color}
                          />
                        )
                      )}
                    </Pie>

                    <Tooltip
                      formatter={(
                        value,
                        name
                      ) => [
                        `₹${Number(
                          value || 0
                        ).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}`,
                        name,
                      ]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100 text-muted small">
                  No payment collection found
                </div>
              )}
            </div>

            <div
              className="px-3 py-2 border-top"
            >
              {paymentData &&
              paymentData.length > 0 ? (
                <div className="d-flex flex-column gap-2">
                  {paymentData.map(
                    (entry, index) => (
                      <div
                        key={`payment-detail-${index}`}
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "13px",
                        }}
                      >
                        <span
                          className="rounded-circle d-inline-block me-2"
                          style={{
                            width: "10px",
                            height: "10px",
                            background:
                              entry.color,
                          }}
                        />

                        {entry.name}
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="text-center text-muted small">
                  No payment data
                </div>
              )}
            </div>
          </div>
        </div>

        {/* INVENTORY */}
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">

            <div className="card-header bg-white border-0">
              <h4 className="fw-bold mb-0">
                Inventory Stock
              </h4>
            </div>

            <div
              className="table-responsive"
              style={{
                maxHeight: "220px",
                overflowY: "auto",
              }}
            >
              <table className="table table-sm mb-0 align-middle">
                <thead
                  className="sticky-top"
                  style={{
                    background: "#1fb6d4",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>Item Name</th>
                    <th className="text-end">
                      Stock
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {inventoryData.length > 0 ? (
                    inventoryData
                      .slice(0, 10)
                      .map((item, index) => (
                        <tr
                          key={
                            item.id || index
                          }
                        >
                          <td>
                            {item.item_name ||
                              item.itemName ||
                              item.name ||
                              "-"}
                          </td>

                          <td className="text-end">
                            {item.stock ?? 0}
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center text-muted py-4"
                      >
                        No inventory data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

      {/* =========================
          LATEST SALES
      ========================= */}
      <div className="row g-3">

        <div className="col-12 col-lg-9">
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

            <div className="card-header bg-white border-0 d-flex align-items-center justify-content-between gap-2">
              <h4 className="fw-bold mb-0">
                Latest Sale Transactions
              </h4>

              <span
                className="text-nowrap"
                style={{
                  color: "#ff5b7f",
                  cursor: "pointer",
                }}
              >
                See all
              </span>
            </div>

            <div className="table-responsive">
              <table className="table mb-0 align-middle">
                <thead
                  style={{
                    background: "#1fb6d4",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>Inv. No.</th>
                    <th>Customer Name</th>
                    <th>Date</th>
                    <th>Payment Mode</th>
                    <th className="text-end">
                      Total
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {saleBill.length > 0 ? (
                    saleBill
                      .slice(0, 5)
                      .map((item, index) => (
                        <tr
                          key={
                            item.id ||
                            item.invoiceNo ||
                            index
                          }
                        >
                          <td>
                            {item.invoiceNo ||
                              item.id ||
                              "-"}
                          </td>

                          <td>
                            {item.customerName ||
                              item.customer_name ||
                              item.customer ||
                              item.name ||
                              "-"}
                          </td>

                          <td>
                            {item.date || "-"}
                          </td>

                          <td>
                            {item.payment_method ||
                              item.paymentMethod ||
                              item.payment_mode ||
                              item.paymentMode ||
                              item.mode ||
                              item.payment ||
                              "-"}
                          </td>

                          <td className="text-end text-nowrap">
                            ₹
                            {Number(
                              item.totalSP ||
                                item.total ||
                                item.grandTotal ||
                                item.amount ||
                                0
                            ).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center py-4"
                      >
                        No sale transactions found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>

        {/* EXPENSES */}
        <div className="col-12 col-lg-3">
          <div
            className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden"
            style={{
              minHeight: "280px",
            }}
          >
            <div className="card-header bg-white border-0">
              <h4 className="fw-bold mb-0">
                Expenses by Category
              </h4>
            </div>

            {expenseData &&
            expenseData.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  height: "220px",
                }}
              >
                <ResponsiveContainer
                  width="100%"
                  height="100%"
                >
                  <PieChart>
                    <Pie
                      data={expenseData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="45%"
                      outerRadius={70}
                      label
                    >
                      {expenseData.map(
                        (entry, index) => (
                          <Cell
                            key={`expense-${index}`}
                            fill={entry.color}
                          />
                        )
                      )}
                    </Pie>

                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            ) : (
              <div className="text-center text-muted py-5">
                No expense data found
              </div>
            )}
          </div>
        </div>

      </div>

      <style>{`
        .min-w-0 {
          min-width: 0;
        }

        @media (max-width: 1199.98px) {
          .container-fluid {
            padding-left: 12px !important;
            padding-right: 12px !important;
          }
        }

        @media (max-width: 575.98px) {
          .container-fluid {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }

          .card-body {
            min-width: 0;
          }
        }
          /* ================================
   MAIN CONTENT - REMOVE LEFT GAP
================================ */
.content-area {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: auto !important;
  max-width: none !important;
}

.content-area .container-fluid {
  width: 100% !important;
  max-width: none !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.main-content {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: auto !important;
  max-width: none !important;
}

/* Overview / page container */
.main-content .container-fluid {
  width: 100% !important;
  max-width: none !important;

  padding-left: 8px !important;
  padding-right: 8px !important;
}
      `}</style>
    </div>
  );
};

export default Overview;